export const parseTemplate = (template, values) => {
  let value = template;

  Object.keys(values).forEach(key => {
    value = value.replace(`%${key}%`, values[key]);
  });

  return value;
};
